import {createFileRoute} from '@tanstack/react-router'

import HealthScreen from '@protected/health'

export const Route = createFileRoute('/_protected/health')({component: HealthScreen})
